<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff; margin-left: 10px">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline"
            >
              <el-form-item label="项目" style="margin-bottom: 2px;margin-top: 2px">
                <el-select v-model="projectId" placeholder="当前项目" style="width: 150px">
                  <el-option
                      style="width: 300px"
                      :key="index"
                      v-for="(item, index) in product"
                      :label="item.name"
                      :value="item.projectId"
                  >
                    <div @click="getChangeProduct(item)">{{ item.name }}</div>
                  </el-option>
                </el-select>&nbsp;
                <el-button
                    type="primary"
                    plain
                    @click="addSubmit"
                >新增
                </el-button
                >
              </el-form-item>
              <el-form-item style="margin-bottom: 2px;margin-top: 2px">
              <span class="btn-r">
                <el-button
                    type="primary"
                    icon="el-icon-export"
                    @click="exportExcel()"
                >导出</el-button
                >
                <el-button icon="el-icon-" @click="searchShow=!searchShow">更多</el-button>
                  <el-button
                      type="primary"
                      @click="searchSubmit"
                  >搜索
                  </el-button
                  ></span>
              </el-form-item>
              <div class="uers-left" style="margin-bottom: 2px;margin-top: 2px">
                <el-form-item label="姓名：" style="margin-bottom: 2px;margin-top: 2px">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机：" style="margin-bottom: 2px;margin-top: 2px">
                  <el-input
                      v-model="searchForm.phone"
                      placeholder="手机"
                  ></el-input>
                </el-form-item>
                <el-form-item label="公司：" style="margin-bottom: 2px;margin-top: 2px">
                  <el-input
                      v-model="searchForm.company"
                      placeholder="公司"
                  ></el-input>
                </el-form-item>
                <el-form-item label="码值：" style="margin-bottom: 2px;margin-top: 2px">
                  <el-input
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                </el-form-item>
                <el-form-item label="编号：" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">
                  <el-input
                      v-model="searchForm.idNumber"
                      placeholder="编号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="rfid：" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">
                  <el-input
                      v-model="searchForm.rfid"
                      placeholder="rfid"
                  ></el-input>
                </el-form-item>
                <el-form-item label="" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">
                  <el-date-picker
                      v-model="searchForm.startDate"
                      type="datetime"
                      placeholder="开始日期"
                  ></el-date-picker>
                  <el-date-picker
                      v-model="searchForm.endDate"
                      type="datetime"
                      placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="证件类型：" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">
                  <el-select
                      v-model="searchForm.documentTypeId"
                      placeholder="证件类型"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                        v-for="(type, index) in DocumentType"
                        :label="type.name"
                        :key="index"
                        :value="type.documentTypeId"
                    >{{ type.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-popover
                      placement="bottom"
                      title="批量导入"
                      width="220"
                      trigger="click"
                  >
                    <div>
                      <el-upload
                          class="upload-demo"
                          :action="action"
                          :auto-upload="false"
                          :on-change="uploadChange"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      >
                        <el-button size="small" type="primary"
                        >选择导入模板
                        </el-button
                        >
                      </el-upload>
                      <el-button
                          type="success"
                          @click="download"
                          plain
                          icon="el-icon-download"
                          class="down-template"
                      >下载模板
                      </el-button
                      >
                    </div>
                    <p class="import-text">只能选择 .xls .xlsx 文件</p>
                    <div>
                      <el-button type="success" @click="importData"
                      >新增
                      </el-button
                      >
                      <el-button type="primary" @click="importDataUpdate"
                      >修改
                      </el-button
                      >
                      <el-button type="danger" @click="importDataDelete"
                      >删除
                      </el-button
                      >
                    </div>
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-upload2"
                        slot="reference"
                    >导入
                    </el-button
                    >
                  </el-popover>
                </el-form-item>
                <!--                <el-form-item label="打印状态：" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">-->
                <!--                  <el-select v-model="searchForm.isPrint">-->
                <!--                    <el-option value="-1" label="全部"></el-option>-->
                <!--                    <el-option value="0" label="未打印"></el-option>-->
                <!--                    <el-option value="1" label="已打印"></el-option>-->
                <!--                  </el-select>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="姓名重复：" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">-->
                <!--                  <el-select v-model="searchForm.isRepeat">-->
                <!--                    <el-option value="0" label="全部"></el-option>-->
                <!--                    <el-option value="1" label="姓名重复"></el-option>-->
                <!--                  </el-select>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="是否写卡：" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">-->
                <!--                  <el-select v-model="searchForm.isRfid">-->
                <!--                    <el-option value="-1" label="全部"></el-option>-->
                <!--                    <el-option value="0" label="未写卡"></el-option>-->
                <!--                    <el-option value="1" label="已写卡"></el-option>-->
                <!--                  </el-select>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item label="拥有头像：" v-if="searchShow" style="margin-bottom: 2px;margin-top: 2px">-->
                <!--                  <el-select v-model="searchForm.isAvatar">-->
                <!--                    <el-option value="-1" label="全部"></el-option>-->
                <!--                    <el-option value="0" label="没有头像"></el-option>-->
                <!--                    <el-option-->
                <!--                        value="1"-->
                <!--                        label="已有头像"-->
                <!--                    ></el-option>-->
                <!--                  </el-select-->
                <!--                  >-->
                <!--                </el-form-item>-->
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                :height="300"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  prop="name"
                  width="100"
                  label="姓名/手机号"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.phone }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="avatar"
                  width="60"
                  label="头像"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.avatar"
                        :preview-src-list="[scope.row.avatar]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="code"
                  label="码值/编号"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.code }}</p>
                  <p>{{ scope.row.idNumber }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="idCard"
                  width="150"
                  label="身份证/rfid"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.idCard }}</p>
                  <p>{{ scope.row.rfid }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="company"
                  width="150"
                  label="公司/团组/职位"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.company }}</p>
                  <p>{{ scope.row.groupNo }}</p>
                  <p>{{ scope.row.position }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="idNumber"
                  width="100"
                  label="证件类型"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.typeName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  prop="effectiveStart"
                  label="有效时间"
                  align="center"
                  width="150"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.effectiveStart }}</p>
                  <p>{{ scope.row.effectiveEnd }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="100"
                  prop="isPrint"
                  label="状态"
                  align="center"
              >
                <template slot-scope="scope">
                  <p>三要素:{{ scope.row.status ? scope.row.status : "无" }}</p>
                  <p>zd:{{ scope.row.zd ? scope.row.zd : "无" }}</p>
                  <p>二要素:{{ scope.row.status2 ? scope.row.status2 : "无" }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  width="200"
                  prop="printDate"
                  label="创建/打印/入库时间"
                  align="left"
              >
                <template slot-scope="scope">
                  <p>已创建：{{ scope.row.createDate }}</p>
                  <p>{{ scope.row.isPrint ? "已打印" : "未打印" }}：{{ scope.row.printDate }}</p>
                  <p>{{ scope.row.isMake ? "已入库" : "未入库" }}：{{ scope.row.makeDate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center" fixed>
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      v-if="!(gb&&roles==='业务员')"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, prev,  next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditDocument
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditDocument>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import {Loading} from "element-ui";
import EditDocument from "../../../components/ticketing/certificate/EditDocument";
import DocumentType from "../../../components/ticketing/certificate/docuType/DocumentType";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      searchShow: false,
      fileList: [],
      product: [],
      DocumentType: [],
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 15, // 每页的数据
      //表格高度适配
      tabheight: "",
      roles: localStorage.getItem("roles"),
      gb: window.location.hostname.indexOf('gb') > -1,
      accountId: localStorage.getItem("accountId"),
      searchForm: {
        groupNo: "",
        name: "",
        code: "",
        phone: "",
        idNumber: "",
        documentTypeId: "0",
        isRepeat: "0",
        isPrint: "-1",
        isRfid: "-1",
        company: "",
        rfid: "",
        isAvatar: "-1",
        remark: "",
        endDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
        startDate: new Date(
            new Date(new Date().toLocaleDateString()).getTime() -
            (new Date(new Date().toLocaleDateString()).getTime() -
                new Date(new Date().getFullYear().toString()))
        ),
      },
      editData: {},
      listShow: true,
      delVisible: false,
      document_Id: "",
      editShow: false,
      dataList: [],
      dataType: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      action: localStorage.getItem("url") + "/Upload/File?eId=" + localStorage.getItem("project_Id"),
      attr: [],
      ids: [],
    };
  },
  mounted() {
    if (document.documentElement.clientHeight < 900) {
      this.pagesize = 15;
    }
    this.getData();
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getProject();
    this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
      if (res.data.hasError == false) {
        this.DocumentType = [...res.data.data];
      }
    });
  },
  methods: {
    getChangeProduct(row) {
      this.$axios
          .get(
              `/Account/Project/${this.ruleForm.id}/${row.name}/${row.projectId}`
          )
          .then((res) => {
            if (res.data.hasError == true) {
              this.$message.error(res.data.message);
            } else {
              localStorage.setItem("project_Id", row.projectId);
              this.projectId = row.projectId
            }
          });
    },
    getProjectRole(dd) {
      dd.forEach((item, index) => {
        if (localStorage.getItem("project_Id") == item.projectId) {
          localStorage.setItem("startDate", item.startDate);
        }
      });
      this.$axios
          .get(`/AccountProjectRole/Project/${this.accountId}`)
          .then((res) => {
            if (res.data.hasError == false) {
              if (res.data.data && res.data.data.length > 0) {
                let ids = new Array();
                for (let i = 0; i < res.data.data.length; i++) {
                  ids.push(res.data.data[i].projectId);
                }
                let bb = new Array();

                dd.forEach((item, index) => {
                  if (ids.indexOf(item.projectId) < 0) {
                  } else {
                    bb.push(item);
                    this.projectId = item.projectId;
                    this.project = item.name;
                  }
                });
                this.product = [...bb];
                localStorage.setItem("global", false);
              } else {
                this.product = [...dd];
                localStorage.setItem("global", true);
              }
            }
          });
    },
    getProject() {
      // if (localStorage.getItem("roles") === "公安人员" ||
      //     localStorage.getItem("roles") === "夜值人员") {
      //   this.$axios.get(`/Project/ProjectType/1`).then((res) => {
      //     if (res.data.hasError == false) {
      //       this.product = [...res.data.data];
      //       localStorage.setItem("global", false);
      //     }
      //   });
      // } else {
      //
      //   this.$axios
      //       .get(`/AccountProjectRole/Project/${this.accountId}`)
      //       .then((res) => {
      //         if (res.data.hasError == false) {
      //           if (res.data.data && res.data.data.length > 0) {
      //             let ids = new Array();
      //             for (let i = 0; i < res.data.data.length; i++) {
      //               ids.push(res.data.data[i].projectId);
      //             }
      //             let bb = new Array();
      //
      //             dd.forEach((item, index) => {
      //               if (ids.indexOf(item.projectId) < 0) {
      //                 if (item.projectId === this.projectId) {
      //                   bb.push(item);
      //                 }
      //               } else {
      //                 bb.push(item);
      //               }
      //             });
      //             this.product = [...bb];
      //             localStorage.setItem("global", false);
      //           } else {
      //             if (localStorage.getItem("roles") !== "超级管理员") {
      //               let bb = new Array();
      //
      //               dd.forEach((item, index) => {
      //                 if (item.projectId === this.projectId) {
      //                   bb.push(item);
      //                 }
      //               });
      //               this.product = [...bb];
      //               localStorage.setItem("global", false);
      //             } else {
      //               this.product = [...dd];
      //               localStorage.setItem("global", true);
      //             }
      //           }
      //         }
        // this.$axios.get(`/Project/`).then((res) => {
        //   if (res.data.hasError == false) {
        //     this.getProjectRole(res.data.data);
        //   }
        // });
      // }
    },
    //  文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.$message.warning("文件已移除");
    },
    handleChange(file, fileList) {
      this.fileList = this.fileList.slice(-1);
    },
    handleExceed() {
      //提示最多只能上传1个
      this.$message.warning("最多上传1个文件！");
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    upload(file, fileList) {
      this.file = event.currentTarget.files[0];
      const limitSize = 1024 * 1024 * 100;
      if (this.file.size > limitSize) {
        alert("文件大小不能超过100MB");
      }
      let formData = new FormData();
      formData.append('file', this.file);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.post("/Upload/File?eId=" + this.projectId, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(res => {
        if (res.data.hasError == false) {
          this.$message.success(res.data.message)
        } else {
          this.$message.error('操作失败')
        }
        loading.close();
        this.fileList = this.fileList.slice(-1);
      }).catch((e) => {
        this.$message.error("操作失败");
        loading.close();
      });
    },
    exportExcel() {
      var search = {
        projectId: this.projectId,
        name: this.searchForm.name,
        code: this.searchForm.code,
        isPrint: this.searchForm.isPrint,
        isAvatar: this.searchForm.isAvatar,
        idNumber: this.searchForm.idNumber,
        company: this.searchForm.company,
        groupNo: this.searchForm.groupNo,
        rfid: this.searchForm.rfid,
        documentTypeId: this.searchForm.documentTypeId,
        pageIndex: 0,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        isRfid: this.searchForm.isRfid,
        pageSize: this.total,
        remark: this.searchForm.remark,
        phone: this.searchForm.phone,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
          .post(`/Document/Export`, search)
          .then((res) => {
            loading.close();
            if (res.data.data) {
               window.open(res.data.data, '_self');
              // this.$download(res.data.data, '导出证件.xlsx');
            } else {
              this.$message.error("导出失败");
            }
          })
          .catch((a) => {
            loading.close();
            this.$message.error("导出失败");
          });
    }, downLoad(url, fileName) {
      return fetch(url).then((res) => {
        res.fetch(url).then((blob) => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        });
      });
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          let codes = [];
          outdata.map((v) => {
            let obj = {};
            obj.documentId = v.ID;
            obj.name = v.姓名;
            if (v.名称) {
              obj.name = v.名称;
            }
            obj.phone = v.手机号;
            obj.code = v.二维码值;
            obj.idNumber = v.证件编号;
            obj.avatar = v.头像;
            obj.originalImg = v.原图;
            obj.remark = v.备注;
            obj.company = v.公司;
            obj.position = v.职务;
            obj.idCard = v.身份证号;
            obj.sex = v.性别;
            obj.rfid = v.rfid;
            obj.isPrint = false;
            obj.groupNo = v.团组;
            obj.address = v.地址;
            obj.area = v.地区;
            obj.effectiveStart = v.有效时间开始;
            obj.effectiveEnd = v.有效时间结束;
            obj.companyEn = v.英文公司;
            obj.nameEn = v.英文名称;
            obj.positionEn = v.英文职务;
            obj.addressEn = v.英文地址;
            obj.email = v.邮箱;
            obj.market = v.参与论坛;
            obj.business = v.业务范围;
            obj.profile = v.业务类型;
            obj.typeName = v.证件类型;
            obj.visit = v.座位号;
            obj.status = v.状态;
            obj.role = v.参会身份;
            obj.hotel = v.酒店;
            obj.roomtype = v.房间类型;
            obj.roomNo = v.房间号;
            obj.booth = v.展位;
            obj.departureTime = v.离店类型;
            obj.checkInTime = v.入住时间;
            obj.remark1 = v.备注1;
            obj.remark2 = v.备注2;
            obj.remark3 = v.备注3;
            obj.remark4 = v.备注4;
            obj.remark5 = v.备注5;
            ar.push(obj);
            if (v.二维码值) {
              codes.push(v.二维码值);
            }
          });
          localStorage.setItem("attr", JSON.stringify(ar));
          localStorage.setItem("ids", JSON.stringify(codes));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    download() {
      let url = localStorage.getItem("url");
      if (url.lastIndexOf("/api") == url.indexOf("/api")) {
        // if (window.location.hostname.indexOf("gb") > -1) {
        window.open(url.replace("/api", "/") + "/data/导入模板.xlsx");
        // } else {
        //   window.open(url.replace("/api", "/") + "/data/证件模板.xlsx");
        // }
      } else {
        if (window.location.hostname.indexOf("gb") > -1) {
          window.open(
              url.substring(0, url.lastIndexOf("/api")) +
              "/data/导入模板.xlsx"
          );
        } else {
          window.open(
              url.substring(0, url.lastIndexOf("/api")) +
              "/data/证件模板.xlsx"
          );
        }
      }
      // window.open(
      //   localStorage.getItem("url").replace("/api", "/") +
      //     "/upload/证件模板.xlsx"
      // );
    },
    setAvatar() {
      if (this.searchForm.documentTypeId != "0") {
        if (confirm("是否清除证件头像")) {
          this.$axios
              .delete(`/Document/Avatar/${this.searchForm.documentTypeId}`)
              .then((res) => {
                if (res.data.hasError) {
                  this.$message.error(res.data.message);
                } else {
                  this.$message.success("清除成功！");
                  this.getData();
                }
              });
        }
      } else {
        this.$message.error("请选择证件类型");
      }
    },
    importData() {
      if (this.searchForm.documentTypeId != "0") {
        this.attr = JSON.parse(localStorage.getItem("attr"));
        if (this.attr && this.attr.length > 0) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let url = "/Document/AddList/" + this.searchForm.documentTypeId;
          if (window.location.hostname.indexOf("gb") > -1) {
            url = "/gb" + url
          }

          this.$axios
              .put(url, this.attr)
              .then((res) => {
                if (res.data.hasError == false) {
                  loading.close();
                  localStorage.setItem("attr", null);
                  this.getData();
                  this.$message.success(res.data.message);
                } else {
                  this.$message.error(res.data.message);
                  loading.close();
                }
              })
              .catch(function () {
                loading.close();
              });
        } else {
          this.$message.error("没有可上传的数据");
        }
      } else {
        this.$confirm("没有选择证件类型，是否导入多种证件？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.attr = JSON.parse(localStorage.getItem("attr"));
          this.$axios
              .put("/Document/import/" + this.projectId, this.attr)
              .then((res) => {
                if (res.data.hasError == false) {
                  loading.close();
                  localStorage.setItem("attr", null);
                  this.getData();
                  this.$message.success(res.data.message);
                } else {
                  this.$message.error(res.data.message);
                  loading.close();
                }
              })
              .catch(function () {
                loading.close();
              });
        });
      }
    },
    importDataDelete() {
      this.ids = JSON.parse(localStorage.getItem("ids"));
      if (this.ids && this.ids.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
            .put("/Document/BatchDelete/" + this.projectId, this.ids)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                localStorage.setItem("attr", null);
                this.getData();
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }

    },
    importDataUpdate() {
      this.attr = JSON.parse(localStorage.getItem("attr"));
      if (this.attr && this.attr.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$axios
            .put("/Document/UpdateList/" + this.projectId, this.attr)
            .then((res) => {
              if (res.data.hasError == false) {
                loading.close();
                localStorage.setItem("attr", null);
                this.getData();
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
                loading.close();
              }
            })
            .catch(function () {
              loading.close();
            });
      } else {
        this.$message.error("没有可上传的数据");
      }

    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
      console.log(`每页 ${val} 条`);
    },
    handleSync(index, row) {
      this.$axios.get(`/Document/syncOne/${row.documentId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("同步成功！");
          this.getSearch();
        }
      });
    },
    handlePrinter(index, row) {
      window.open(localStorage.getItem("url") + "/printer/" + row.documentId);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.getSearch();
      this.attr = [];
    },
    getSearch() {
      var search = {
        projectId: this.projectId,
        name: this.searchForm.name,
        code: this.searchForm.code,
        isPrint: this.searchForm.isPrint,
        isRepeat: this.searchForm.isRepeat,
        isRfid: this.searchForm.isRfid,
        isAvatar: this.searchForm.isAvatar,
        idNumber: this.searchForm.idNumber,
        company: this.searchForm.company,
        remark: this.searchForm.remark,
        groupNo: this.searchForm.groupNo,
        rfid: this.searchForm.rfid,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        documentTypeId: this.searchForm.documentTypeId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        phone: this.searchForm.phone,
      };
      this.$axios.post("/Document/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    addSubmit() {
      this.document_Id = "";
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    syncData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios.get(`/Document/sync/${this.projectId}`).then((res) => {
        loading.close();
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("同步成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    handleDelete(index, row) {
      this.document_Id = row.documentId;
      this.delVisible = true;
    },
    deleteData() {
      this.$axios.delete(`/Document/${this.document_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    handleCloseVisible() {
      this.document_Id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditDocument,
    DocumentType,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  height: 100%;
  margin-left: 10px;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-left {
  float: left;
}

.uers-right {
  float: right;
  margin-bottom: 20px;
}

.btn-r {
  margin-right: 20px;
}

.file-up {
  width: 100px;
  position: absolute;
  height: 32px;
  opacity: 0;
}

.import-text {
  margin: 15px 0;
}

.el-upload--text {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border: 0;
}

.down-template {
  position: absolute;
  top: 40px;
  right: 10px;
}

.pag {
  float: left;
}

.el-dialog {
  height: auto;
}
</style>